/**
 * Created by olga on 13.01.2026
 *
 */

const NewTaskProgressBar = ScaledProgressBar.extend({
    ctor: function (options = {}) {
        const frames = options.frames;

        this._super({
            type: {
                progressFull: frames.progressFull,
                progressCut: frames.progressFull,
                progressNext: frames.progressNext,
                background: frames.background,
                delimiter: frames.delimiter
            },
            showAllDelimiters: true,
            animateInSectorMode: true,
            barText: options.barText
        });

        this.delimitersOnlyAhead = options.delimitersOnlyAhead;
        this.noProgressNext = options.noProgressNext;
        this.fillInset = options.fillInset || 0;

        this.updateCapInsets(this.progress);

        if (this.barText) {
            this.barText.setLocalZOrder(3);
        }
    },

    updateCapInsets: function (sprite) {
        const size = cc.size(sprite.getSpriteFrame().resolve().getOriginalSize());
        sprite.setCapInsets(cc.rect(size.width * 0.5 - 1, size.height / 3, 2, size.height / 3));
    },

    getFillLength: function (sectors) {
        if (sectors >= this.to) {
            return this.width;
        }

        if (sectors <= 0) {
            return 0;
        }

        return Math.min(this.width, sectors * this.width / this.to + this.fillInset);
    },

    updateSectorProgress: function () {
        this.progress.setContentSize(this.getFillLength(this.from), this.height);
    },

    updateDelimiters: function () {
        this._super();

        if (this.delimitersOnlyAhead) {
            this.delimiters.forEach((delimiter, index) => {
                delimiter.setVisible(index + 1 > this.from);
            });
        }
    },

    showProgressNext: function (silent) {
        if (this.noProgressNext) {
            return;
        }

        const nextProgress = Math.min((this.from + 1), this.to);

        if (this.shownNextProgress === nextProgress) {
            return;
        }

        this.shownNextProgress = nextProgress;

        if (!this.progressNext) {
            this.progressNext = cleverapps.UI.createScale9Sprite(this.options.progressNext);
            this.progressNext.setAnchorPoint(0, 0);
            this.addChild(this.progressNext, -1);
            this.updateCapInsets(this.progressNext);
        }

        this.progressNext.setContentSize(this.getFillLength(nextProgress), this.height);

        if (silent) {
            this.progressNext.setOpacity(255);
        } else {
            this.progressNext.setOpacity(0);
            this.progressNext.runAction(new cc.FadeIn(0.2));
        }
    },

    hideProgressNext: function () {
        if (this.progressNext) {
            this.progressNext.setOpacity(0);
        }

        this.shownNextProgress = undefined;
    },

    setPercentage: function (from, options) {
        options = options || {};
        this.stopChangeAction();

        from = Math.max(Math.min(from, this.to), 0);

        if (options.animated) {
            this._animatedChange(from, options);
        } else {
            this.from = from;
            this.onChange(true);
            options.callback && options.callback();
        }
    }
});
